(() => {
  // Re-runs Trustpilot on home widgets if the bootstrap loaded before they were parsed.
  function loadTrustpilot() {
    if (!window.Trustpilot || typeof window.Trustpilot.loadFromElement !== 'function') return false;
    document.querySelectorAll('.enzo-tp').forEach(element => {
      if (!element.querySelector('iframe')) window.Trustpilot.loadFromElement(element, true);
    });
    return true;
  }
  addEventListener('load', () => { if (!loadTrustpilot()) setTimeout(loadTrustpilot, 3000); });
  document.addEventListener('shopify:section:load', loadTrustpilot);

  // Compact Trustpilot badge for small screens: live TrustScore and review count.
  const WORDS = {
    it: { on: 'su Trustpilot', reviews: 'recensioni verificate' },
    en: { on: 'on Trustpilot', reviews: 'verified reviews' },
    de: { on: 'auf Trustpilot', reviews: 'verifizierte Bewertungen' },
    fr: { on: 'sur Trustpilot', reviews: 'avis vérifiés' },
    es: { on: 'en Trustpilot', reviews: 'opiniones verificadas' },
    pt: { on: 'no Trustpilot', reviews: 'avaliações verificadas' }
  };
  function fillMini() {
    document.querySelectorAll('.enzo-tp-mini[data-bu]:not([data-ready])').forEach(async badge => {
      badge.dataset.ready = '1';
      const lang = (document.documentElement.lang || 'it').slice(0, 2);
      const words = WORDS[lang] || WORDS.it;
      try {
        const response = await fetch(`https://widget.trustpilot.com/trustbox-data/5419b6ffb0d04a076446a9af?businessUnitId=${encodeURIComponent(badge.dataset.bu)}&locale=${encodeURIComponent(badge.dataset.locale || 'it-IT')}`);
        if (!response.ok) return;
        const data = await response.json();
        const unit = data.businessUnit || {};
        const total = unit.numberOfReviews && unit.numberOfReviews.total;
        if (!unit.trustScore || !total) return;
        const score = new Intl.NumberFormat(document.documentElement.lang || 'it', { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(unit.trustScore);
        badge.querySelector('strong').textContent = `${score}/5 ${words.on}`;
        badge.querySelector('.enzo-tp-mini__text span').textContent = `${new Intl.NumberFormat(document.documentElement.lang || 'it').format(total)} ${words.reviews}`;
        if (data.links && data.links.profileUrl) badge.href = data.links.profileUrl;
      } catch (error) {}
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fillMini);
  else fillMini();
  document.addEventListener('shopify:section:load', fillMini);
})();
